import { z } from 'zod';
import { apiEnvelope } from './v1.js';

/**
 * `GET /v1/me` — WHO the gateway thinks you are (A6a / IDEA-68, the DEVOP-4 slice).
 *
 * Answers with the request's DERIVED owner (the id every owner-scoped write/read on
 * this request uses — server-derived, never client-supplied), the verified Access
 * identity when enforcement produced one, and whether in-Worker enforcement is on.
 * The identity is the login EMAIL only — the raw Access token, `sub`, and the
 * service-token `common_name` are never echoed: Cloudflare puts the service-token
 * CLIENT ID in `sub`/`common_name`, so echoing either would leak half of a machine
 * credential (A6a review). A service-token login reports `identity: null`.
 */
export const MeIdentitySchema = z.object({
  /** Login email from the verified JWT; a non-email identity reports `identity: null`. */
  email: z.string().min(1).max(320),
});
export type MeIdentity = z.infer<typeof MeIdentitySchema>;

export const MeDataSchema = z.object({
  /** The derived owner id this request acts as (config pin / DEV_OWNER_ID). */
  owner: z.string().min(1).max(120),
  /** Verified identity claims; `null` when Access is off or the token carried none. */
  identity: MeIdentitySchema.nullable(),
  /** True only when the in-Worker Access guard is actively enforcing (`enforced`). */
  accessEnforced: z.boolean(),
});
export type MeData = z.infer<typeof MeDataSchema>;

export const MeResponseSchema = apiEnvelope(MeDataSchema);
export type MeResponse = z.infer<typeof MeResponseSchema>;
